import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MingaRoleType } from 'libs/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthInfoService } from '@app/src/app/minimal/services/AuthInfo';
import { cacheBustUrl } from '@app/src/app/util/image';

@Component({
  selector: 'mg-person-avatar',
  templateUrl: './PersonAvatar.component.html',
  styleUrls: ['./PersonAvatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// The current persons avatar.
export class PersonAvatarComponent {
  public displayName: string;
  public avatarUrl: string;
  public color: string;

  @Input() noDisplayName: boolean;
  @Input() borderless: boolean;

  public readonly avatarUrl$: Observable<string> = this._auth.authPerson$.pipe(
    map(person => {
      return person ? cacheBustUrl(person.avatarUrl) || '' : '';
    }),
  );
  public readonly filename$: Observable<string> = this._auth.authPerson$.pipe(
    map(person => (person ? person.filename : '')),
  );

  public readonly role$: Observable<MingaRoleType> = this._auth.authPerson$.pipe(
    map(person => person.role as MingaRoleType),
  );

  public readonly displayName$: Observable<string> = this._auth.authPerson$.pipe(
    map(person => (person ? person.displayName || '' : '')),
  );
  public readonly color$: Observable<string> = this._auth.authPerson$.pipe(
    map(person => (person ? person.badgeIconColor || '' : '')),
  );

  constructor(private _auth: AuthInfoService) {}
}
